import { canvasLabelMeasurer } from '@ardoq/graph-labeling';
import { ARDOQ_DEFAULT_FONT_FAMILY } from '@ardoq/typography';

const LEGACY_NODE_LABEL_FONT = `normal 32px/normal ${ARDOQ_DEFAULT_FONT_FAMILY}`;
export const measureNodeLabelWidth = canvasLabelMeasurer(
  LEGACY_NODE_LABEL_FONT
);

export const LEGACY_NODE_LABEL_MAX_WIDTH = 300;
